'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _defaultMatchComponent = require('./defaultMatchComponent');

var _defaultMatchComponent2 = _interopRequireDefault(_defaultMatchComponent);

var _defaultMatchMeComponent = require('./defaultMatchMeComponent');

var _defaultMatchMeComponent2 = _interopRequireDefault(_defaultMatchMeComponent);

var _selectors = require('../selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseMatch = function parseMatch(match) {
  if (isNaN(match) || match == 0) {
    return 0;
  } else if (match) {
    return (match * 100).toFixed(0);
  }

  return 'No match';
};

var renderMatchMe = function renderMatchMe(matchMeComponent) {
  if (matchMeComponent) {
    return matchMeComponent();
  }

  return (0, _defaultMatchMeComponent2.default)();
};

function MatchTooltip(_ref) {
  var hasMatched = _ref.hasMatched,
      match = _ref.match,
      matchMeComponent = _ref.matchMeComponent,
      matchComponent = _ref.matchComponent,
      matchMe = _ref.matchMe,
      _class = _ref._class;

  var parsedMatch = parseMatch(match) + '%';

  if (hasMatched) {
    return _react2.default.createElement(
      'div',
      {
        className: _class
      },
      matchComponent ? matchComponent(parsedMatch) : (0, _defaultMatchComponent2.default)(parsedMatch)
    );
  }

  return _react2.default.createElement(
    'div',
    {
      className: _class,
      onClick: function onClick() {
        matchMe(true);
      }
    },
    renderMatchMe(matchMeComponent)
  );
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps, _selectors.mapDispatchToProps)(MatchTooltip);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/MatchTooltip/components/MatchTooltip.jsx
// module id = 1095
// module chunks = 0